(function () {
    'use strict';

    var module = angular.module('inoApp.directives.layout');

    module.directive('layoutHeaderSearch', [function () {
        var directive = {
            restrict: 'AE',
            replace: true,
            templateUrl: 'templates/core/layout/header_search.html',
        };

        return directive;
    }]);
})();